import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import clip from '@/utils/clipboard'; // use clipboard directly
import SearchBar from '@/components/SearchV3/index.vue';
import ActionBar from '@/components/ActionBar/index';
import searchMixin from '@/mixin/search';
import TableList from '../components/table.vue';
import Pagination from '@/components/Pagination/index.vue';
import { fetchBlogList, deleteBlog, publishBlog } from '@/api/website/blog';
import { blogLangType, blogType } from '../config';
import { NODE_ENV } from '@com/config/env';
import { websiteHost } from '@/config/host';

export default {
  components: {
    ActionBar: ActionBar,
    SearchBar: SearchBar,
    TableList: TableList,
    Pagination: Pagination
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      query: {
        order: '-id,title',
        page: 1,
        page_size: 15
      },
      pagination: {
        total: 0
      },
      listLoading: false,
      list: [],
      formItemList: [{
        type: 'select',
        prop: 'lang',
        params: {
          disabled: false,
          readonly: false,
          placeholder: '请输入语言版本',
          options: blogLangType
        }
      }, {
        type: 'select',
        prop: 'type',
        params: {
          disabled: false,
          readonly: false,
          placeholder: '请输入博客类型',
          options: blogType
        }
      }, {
        type: 'input',
        prop: 'keyword',
        subtype: 'text',
        params: {
          clearable: true,
          placeholder: '请输入博客标题'
        }
      }],
      columnConfig: ['id', 'lang', 'title', 'blogType', 'publish_time', 'updated_time', 'setting-cell', 'top-cell', 'action-cell']
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.getList(this.query);
    }
  },
  mounted: function mounted() {
    this.getList(this.query);
  },

  computed: {
    previewUrl: function previewUrl() {
      var url = {
        development: 'http://mw-test.mindworks-creative.com',
        test: 'http://mw-test.mindworks-creative.com',
        production: websiteHost
      };

      return url[NODE_ENV];
    },
    tableConfig: function tableConfig() {
      var config = {};
      if (this.$route.query && this.$route.query.order) {
        config = {
          'default-sort': {
            prop: this.$route.query.order.replace('-', ''),
            order: this.$route.query.order.indexOf('-') !== -1 ? 'descending' : 'ascending'
          }
        };
      } else {
        config = {};
      }
      return config;
    }
  },
  methods: {
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '-id,title';
      }
      this.$router.push({
        query: this.query
      });
    },
    handleCopyLink: function handleCopyLink(text, event) {
      clip(text, event);
      this.$message({
        type: 'success',
        message: '复制成功'
      });
    },
    getList: function getList(query) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var postData, res, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                postData = query;
                // 固定search_field值

                if (postData.keyword) postData.search_field = 'title';
                _this.listLoading = true;
                _context.prev = 3;
                _context.next = 6;
                return fetchBlogList(postData);

              case 6:
                res = _context.sent;

                _this.listLoading = false;
                list = _.get(res, 'data.data.list', []);

                if (list) {
                  list.map(function (item) {
                    item.blogType = item.type;
                  });
                }
                _this.list = list;
                _this.pagination.total = _.get(res, 'data.data.total', 0);
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.listLoading = false;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 14]]);
      }))();
    },
    handleDelete: function handleDelete(_ref2) {
      var _this2 = this;

      var row = _ref2.row;

      this.$confirm('是否确认删除当前博客？', '提示', {
        type: 'warning'
      }).then(function () {
        _this2.deleteBlogItem(row);
      }).catch(function () {
        //
      });
    },
    deleteBlogItem: function deleteBlogItem(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.listLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return deleteBlog(row.id, {});

              case 4:
                res = _context2.sent;

                _this3.listLoading = false;
                if (_.get(res, 'data.code', '') === 0) {
                  _this3.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  _this3.getList(_this3.query);
                } else {
                  _this3.$message(_.get(res, 'data.msg', ''));
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this3.listLoading = false;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 9]]);
      }))();
    },

    // 授权官网展示
    publishBlogItem: function publishBlogItem(_ref3) {
      var _this4 = this;

      var row = _ref3.row;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.listLoading = true;
                _context3.prev = 1;
                _context3.next = 4;
                return publishBlog(row.id, {
                  status: row.status === 1 ? 2 : 1
                });

              case 4:
                res = _context3.sent;

                if (_.get(res, 'data.code', '') === 0) {
                  _this4.$message({
                    message: '处理成功',
                    type: 'success'
                  });
                } else {
                  _this4.$message(_.get(res, 'data.msg', ''));
                }
                _this4.listLoading = true;
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](1);

                _this4.listLoading = false;

              case 12:
                _this4.getList(_this4.query);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 9]]);
      }))();
    },
    handlePreview: function handlePreview(_ref4) {
      // 跳转预览页

      var row = _ref4.row;
    }
  }
};